import { useSelector } from 'react-redux'
import LabRadiologySummaryReportAsync from './LabRadiologySummaryReportAsync'
import { addLabRadiologyItemWiseJob, updateLabRadiologyItemWiseJob, removeLabRadiologyItemWiseJob } from '../../../../redux/slices/AppSlice'

// The item-wise report has its own navigation entry and backend contract.
// The shared screen keeps filters and export behavior consistent.
const LabRadiologyItemWiseReportAsync = () => (
  <LabRadiologySummaryReportAsync
    jobs={useSelector(state => state.app.labRadiologyItemWiseJobs || [])}
    addJobAction={addLabRadiologyItemWiseJob}
    updateJobAction={updateLabRadiologyItemWiseJob}
    removeJobAction={removeLabRadiologyItemWiseJob}
    endpointBase='/v3/reports/items/lab-radiology-item-wise/jobs'
    reportTitle='Lab & Radiology Item Wise Report'
    fileNamePrefix='lab_radiology_item_wise_report'
  />
)

export default LabRadiologyItemWiseReportAsync
